// @flow

import { combineReducers } from 'redux';

import { reducer as personInfoReducer } from './personInfo/';
import { reducer as socialReducer } from './social/';

export default combineReducers({
  personInfo: personInfoReducer,
  social: socialReducer
});



// WEBPACK FOOTER //
// ./src/store/reducers/user/reducer.js